















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import moment from 'moment';

@Component
export default class TabHistory extends Vue {
  @Prop({ type: String, default: '' }) type!: string;
  @Prop({ type: Object, default: () => {} }) requestItem?: Object;

  @Getter('getterRequestHistories', { namespace: 'request' }) c_getterRequestHistories?: any;
  @Getter('getterInventoryHistories', { namespace: 'inventory' }) c_getterInventoryHistories?: any;

  public dateCtx: any = moment;

  get historyData() {
    switch (this.type) {
      case 'request':
        return this.c_getterRequestHistories;
      case 'inventory':
        return this.c_getterInventoryHistories;
    }
  }
}
